"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ahrfPhysicians = {
    name: 'ahrf-physicians',
    tableType: 'fact',
    grain: [
        'zip-geo:state_fips',
        'year::key',
    ],
    tableGrain: [
        'fips',
        'year_key',
    ],
    foreignKeys: [],
};
const clinic = {
    name: 'clinic',
    tableType: 'dim',
    idField: 'npi',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: [
        '!clinic',
        '!npi'
    ],
    foreignKeys: ['zip-geo::key'],
};
const geriatricianVolume = {
    name: 'geriatrician-volume',
    tableType: 'fact',
    grain: ['provider::key', 'year::key'],
    tableGrain: ['!provider', 'year_key'],
    foreignKeys: ['provider::key'],
};
const groupGeriatricianVolume = {
    name: 'group-geriatrician-volume',
    tableType: 'fact',
    grain: ['provider-group::key', 'year::key'],
    tableGrain: ['!provider-group', 'year_key'],
    foreignKeys: ['provider-group::key'],
};
const physGrpPatientExperience = {
    name: 'physician-group-patient-experience',
    altName: 'physiciangroup-pat-exp',
    tableType: 'fact',
    grain: [
        'provider-group::key',
        'year::key',
    ],
    tableGrain: [
        '!provider-group',
        'year_key',
    ],
    foreignKeys: ['provider-group::key'],
};
const physGrpPerformance = {
    name: 'physician-group-performance',
    altName: 'physiciangroup-performance',
    tableType: 'fact',
    grain: [
        'provider-group::key',
        'year::key',
    ],
    tableGrain: [
        '!provider-group',
        'year_key',
    ],
    foreignKeys: ['provider-group::key'],
};
const physicianPerformance = {
    name: 'physician-performance',
    tableType: 'fact',
    grain: [
        'provider::key',
        'year::key',
    ],
    tableGrain: [
        '!provider',
        'year_key',
    ],
    foreignKeys: ['provider::key'],
};
const provider = {
    name: 'provider',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!provider'],
    foreignKeys: ['zip-geo::key'],
};
const providerEocByDrgGroup = {
    name: 'provider-episodes-of-care-by-drg-group',
    tableType: 'fact',
    grain: [
        'drg_group',
        'year::key',
        'provider::key'
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        'drg_group',
        '!provider',
        'year_key',
    ],
    foreignKeys: ['provider::key'],
};
const providerGroupCensus = {
    name: 'provider-group-census',
    altName: 'physiciangroup-census',
    tableType: 'fact',
    grain: [
        'provider-group::key',
    ],
    tableGrain: ['!provider-group'],
    foreignKeys: ['provider-group::key'],
};
const providerGroup = {
    name: 'provider-group',
    altName: 'physiciangroup',
    tableType: 'dim',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!provider-group'],
    foreignKeys: [
        'provider-group::key',
        'zip-geo::key',
    ],
};
const provGrpEhrVendorPenetration = {
    name: 'provider-group-ehr-vendor-penetration',
    altName: 'physiciangroup-ehr-vendor',
    tableType: 'fact',
    grain: [
        'provider-group::key',
        'year::key',
    ],
    tableGrain: [
        '!provider-group',
        'year_key',
    ],
    foreignKeys: ['provider-group::key'],
};
// hospital weight uses the hospital_dim_key
// const provGrpHospitalWeight: DatasetDefinition = {
//     name: 'provider-group-hospital-weight',
//     altName: 'physiciangroup-hospital-weight',
//     tableType: 'fact',
//     grain: [
//         'provider-group::key',
//         '' ??
//     ],
// }
const provGrpMipsPerformance = {
    name: 'provider-group-mips-performance',
    tableType: 'fact',
    grain: [
        'provider-group::key',
        'year::key',
    ],
    tableGrain: [
        '!provider-group',
        'year_key',
    ],
    foreignKeys: ['provider-group::key'],
};
const provGrpNcqaProgramRecognition = {
    name: 'provider-group-ncqa-program-recognition',
    altName: 'physiciangroup-program-recognition',
    tableType: 'fact',
    grain: [
        'provider-group::key',
        'clinic::key',
    ],
    tableGrain: [
        '!provider-group',
        '!clinic',
        'begin_recognition_date',
    ],
    foreignKeys: [
        'provider-group::key',
        'clinic::key',
    ],
};
const providerMedicareProgramParticipation = {
    name: 'provider-medicare-program-participation',
    tableType: 'fact',
    grain: [
        'provider::key',
        'provider-group::key',
        'year-month::key',
    ],
    tableGrain: [
        '!provider',
        '!provider-group',
        'year_month_key',
    ],
    foreignKeys: [
        'provider::key',
        'provider-group::key',
    ],
};
const providerMipsPerformance = {
    name: 'provider-mips-performance',
    tableType: 'fact',
    grain: [
        'provider::key',
        'year::key',
    ],
    tableGrain: [
        '!provider',
        'year_key',
    ],
    foreignKeys: ['provider::key'],
};
const providerNcqaProgramRecognition = {
    name: 'provider-ncqa-program-recognition',
    tableType: 'fact',
    grain: [
        'provider::key',
        'clinic::key',
    ],
    tableGrain: [
        '!provider',
        '!clinic',
        'begin_recognition_date',
    ],
    foreignKeys: [
        'provider::key',
        'clinic::key',
    ],
};
const providerNcqaProgramRecognitionCurrent = {
    name: 'provider-ncqa-program-recognition-current',
    tableType: 'fact',
    grain: [
        'provider::key',
    ],
    tableGrain: [
        '!provider',
    ],
    foreignKeys: ['provider::key'],
};
const providerOtherSupplierVolume = {
    name: 'provider-other-supplier-volume',
    tableType: 'fact',
    grain: [
        'provider::key',
        'year::key',
    ],
    tableGrain: [
        '!provider',
        'year_key',
    ],
    foreignKeys: ['provider::key'],
};
exports.default = [
    ahrfPhysicians,
    clinic,
    geriatricianVolume,
    groupGeriatricianVolume,
    physGrpPatientExperience,
    physGrpPerformance,
    physicianPerformance,
    provider,
    providerEocByDrgGroup,
    providerGroupCensus,
    providerGroup,
    provGrpEhrVendorPenetration,
    provGrpMipsPerformance,
    provGrpNcqaProgramRecognition,
    providerMedicareProgramParticipation,
    providerMipsPerformance,
    providerNcqaProgramRecognition,
    providerNcqaProgramRecognitionCurrent,
    providerOtherSupplierVolume,
];
